import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const FeaturedFiltersWrapper = styled.div`
  .Modality__hideable {
    z-index: 97;
  }

  .Modality__focus_trap {
    z-index: 98;
  }
`;

export const FeaturedFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: ${layout.measurements.spacing050};
`;

export const AppliedFiltersWrapper = styled.div`
  margin: ${layout.measurements.spacing050};
`;
